import { mapGetters } from "vuex";

export const account_form = {
  computed: {
    ...mapGetters(["table_account"]),
    convert_bankbook_options: function() {
      return (item_list, insert_index) => {        
        let option_list = Object.assign([], item_list);
        // memory db에서 account 정보 추출
        let tmp = Object.assign([], this.table_account);
        // account 정보에서 '통장' 정보만 추출
        let account_list = tmp.filter( function(item) { return item.type_id === 2; });
        // item 목록과 account 목록을 병합
        account_list.forEach( function(item, index) {
          let account_item = {};
          account_item.value = '2-' + item.id;
          account_item.label = '통장(' + item.name + ')';
          option_list.splice(index + insert_index, 0, account_item);
        });
        return option_list;
      };      
    },    
  },
  methods: {
    onChangeCollectWayFlag(item) {
      // 수금방법에서 통장관련 아이템이 선택된 경우 처리
      let account_data = item.collect_way_flag_temp.split('-');
      if (account_data.length > 1) {
        item.collect_way_flag = account_data[0];
        item.account_id = account_data[1];
      } else {
        item.collect_way_flag = item.collect_way_flag_temp;
        item.account_id = null;
      }
    },
    onChangePayWayFlag(item) {
      // 결제 방법에 "통장" 관련 아이템이 등록된 경우 처리
      let account_data = item.pay_way_flag_temp.split('-');
      if (account_data.length > 1) {
        item.pay_way_flag = account_data[0];
        item.account_id = account_data[1];
      } else {
        item.pay_way_flag = item.pay_way_flag_temp;
        item.account_id = null;
      }
    },
    getBankAccountName(account_id) {
      // memory db에서 account 정보 추출
      let tmp = Object.assign([], this.table_account);
      // account 정보에서 '통장' 정보만 추출
      let account_list = tmp.filter( function(item) { return item.type_id === 2; });
      let account_info = account_list.find(item => {
        return item.id == account_id;
      });
      return '통장(' + account_info.name + ')';
    },
    getCollectWayFlag(form_data) {
      // 수금 정보에서 등록된 정보를 선택하여 나타나는 다이얼로그에 수금방법을 표시할 때 데이터 처리
      if (form_data) {
        if (form_data.collect_way_flag == '2' && form_data.account_id != null)  {
          let account_method = form_data.collect_way_flag + '-' + form_data.account_id;
          form_data.collect_way_flag_temp = account_method;
        } else {
          form_data.collect_way_flag_temp = form_data.collect_way_flag;
        }
      }
      return form_data;
    },
    getPayWayFlag(form_data) {
      // 결제 정보에서 등록된 정보를 선택하여 나타나는 다이얼로그에 결제방법을 표시할 때 데이터 처리
      if (form_data) {
        if (form_data.pay_way_flag == '2' && form_data.account_id != null ) {
          let account_method = form_data.pay_way_flag + '-' + form_data.account_id;
          form_data.pay_way_flag_temp = account_method;
        } else {
          form_data.pay_way_flag_temp = form_data.pay_way_flag;
        }
      }
      return form_data;
    },
  }
}